import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import { TextField } from "react-md";
import PNXLabel from "./PNXLabel";


interface Props {
  controlProps: controls.FormControl;
  updateValue: (newValue: string) => void;
  onControlBlur: () => void;
};

const PhoenixTextArea = ({
  controlProps,
  updateValue,
  onControlBlur,
} : Props) => {

  const id = `phoenixtextarea-${controlProps.id}`;

  return <div>
    <PNXLabel controlType="label" htmlFor={id} helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
    <TextField
      id={id}
      onChange={(newValue) => { updateValue(`${newValue}`); }}
      onBlur={() => { onControlBlur(); }}
      value={controlProps.value ?? ""}
      placeholder="Enter Value..."
      rows={4}
    />
  </div>;
};

export default PhoenixTextArea;